export class UpdateNotificationPreferenceDto {
    constructor(group, channel, enabled, reasonOfDisabling) {
        this.group = group;
        this.channel = channel;
        this.enabled = enabled;
        this.reasonOfDisabling = reasonOfDisabling;
    }
}
